<div class="header" mat-dialog-actions>
    <div class="navigation desktop">
        <div class="left">

        </div>
        <div class="middle">
            <button (click)="newCategory()" mat-button>New Category</button>
        </div>
        <div class="right">
            <button (click)="close()" mat-button>Close</button>
        </div>
    </div>

    <div class="navigation mobile" *ngIf="loading">
        <div class="left">

        </div>
        <div class="middle">

        </div>
        <div class="right">

        </div>
    </div>
</div>

<div class="container" mat-dialog-content>    
       
    <div class="contentx">
        <div class="category-list">

            <div class="ap-table inventory-table">
                <div *ngFor="let category of categorys; index as i" class="ap-row">
                    <div [style]="getCategoryPlaceholder()" class="placeholder" (click)="selectCategory(category)">
                        <div class="placeholder2" [style]="'background-image: url(' + getThumbImage(category, i) + ')'">
                        </div>
                    </div>
                    <div (click)="selectCategory(category)" class="name">{{category.nicename}}</div>
                    <div class="stats mobile-hide">
                        <div>
                            <span class="">{{getStats(category).needsAttention}}</span> attention
                        </div>
                        <div>
                            <span class="">{{getStats(category).unlisted}}</span> unlisted
                        </div>
                    </div>
                    <div class="mobile-hide">
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>settings</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button (click)="rename(category)" mat-menu-item>Rename</button>
                            <button (click)="fileUpload.click() " mat-menu-item>
                                Change Picture
                                <input style="display: none;" type="file" (change)="changePic($event, category.id, i)" #fileUpload>
                            </button>
                            <button (click)="showSettings(category)" mat-menu-item>Settings</button>
                        </mat-menu>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>